var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('ActBaseMusic',{attrs:{"option":{audioSrc:this.$config.audioSrc,style:{right:'8px',top:'58px'}}}}),_c('ActBaseBottom',{attrs:{"option":_vm.$config.company}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }